import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const state = {
  isLogin: false,
  username: '',
  authTags: []
};

const mutations = {
  changeLogin(state, status){
    state.isLogin = status;
    state.username = localStorage.getItem('username');
  },
  setAuthTags(state, data) {
    state.authTags = JSON.parse(localStorage.getItem('authTags'));
  }
};

const actions = {
  loginAction(context) {
    localStorage.setItem('isLogin', true);
    context.commit('changeLogin', true);
  },
  logoutAction(context) {
    localStorage.clear();
    context.commit('changeLogin', false);
  },
  setAuthTagsAction(context, data) {
    context.commit('setAuthTags', data);
  }

};

const getters = {

};

// const vuexLocal = new VuexPersistence({
//   storage: window.localStorage,
//   reducer: state => ({
//     isLogin: state.isLogin,
//     user: state.user
//   })
// });

export default new Vuex.Store({
  state,
  actions,
  mutations,
  getters
})



// WEBPACK FOOTER //
// ./src/store/index.js